const en_trans_returncuslist = {
    "": "customer return supervision",
    view: "customer return detail",
    add: "add customer return",
    payment: "customer return payment",
}

export default en_trans_returncuslist;